__turbopack_context__.v({
  "gray": "Section-module-scss-module__LwzKGG__gray",
  "lg": "Section-module-scss-module__LwzKGG__lg",
  "md": "Section-module-scss-module__LwzKGG__md",
  "primary": "Section-module-scss-module__LwzKGG__primary",
  "section": "Section-module-scss-module__LwzKGG__section",
  "sm": "Section-module-scss-module__LwzKGG__sm",
  "transparent": "Section-module-scss-module__LwzKGG__transparent",
  "white": "Section-module-scss-module__LwzKGG__white",
  "xl": "Section-module-scss-module__LwzKGG__xl",
});
